import { getBulkData } from './getBulkData'
import { getData } from './getData'

export const TicketController = {
  getData,
  getBulkData,
}
